import { useState } from "react";
import { AlertTriangle, Button, CheckCircle } from "../../ui";
import CopilotPlanCard from "./CopilotPlanCard";
import { discountText, money, pairText } from "./copilotModel";

const ROWS_SHOWN = 8;

// READ answer: the rows come from the database (never from the model).
function QueryResult({ data, t, lang }) {
  const [all, setAll] = useState(false);
  if (!data?.rows?.length) return null;
  const rows = all ? data.rows : data.rows.slice(0, ROWS_SHOWN);
  return (
    <div className="copilot-query">
      <ul className="copilot-rows">
        {rows.map((row) => (
          <li key={row.id}>
            <div className="copilot-row-main">
              <span className="copilot-row-name" dir="auto">
                {pairText(row.name, lang)}
                {row.context && <small> · {pairText(row.context, lang)}</small>}
              </span>
              <span className="copilot-row-change">
                {row.kind === "item" && row.price !== null && row.price !== undefined && money(row.effectivePrice ?? row.price, lang)}
                {row.discount && <small> · {discountText(row.discount, lang)}</small>}
                {row.kind === "section" && t.results(row.count)}
                {row.kind === "addition" && t.values.usedBy(row.restaurantUsage)}
              </span>
            </div>
          </li>
        ))}
      </ul>
      {data.rows.length > ROWS_SHOWN && (
        <Button type="button" variant="primary" appearance="text" size="xs" aria-expanded={all} onClick={() => setAll((v) => !v)}>
          {all ? t.showLess : t.showMore(data.rows.length)}
        </Button>
      )}
    </div>
  );
}

function Clarification({ data, t, lang, disabled, onChoose }) {
  return (
    <div className="copilot-clarify">
      {data.slots.map((slot) => (
        <fieldset key={slot.slot} className="copilot-clarify-slot">
          <legend dir="auto">{slot.question || t.pickOne}</legend>
          <div className="copilot-choices">
            {slot.candidates.map((candidate) => (
              <Button key={candidate.id} type="button" variant="primary" appearance="outline" size="sm" rounded disabled={disabled} onClick={() => onChoose(data.clarificationId, slot.slot, candidate.id)}>
                <span dir="auto">
                  {pairText(candidate.name, lang)}
                  {candidate.context ? ` — ${pairText(candidate.context, lang)}` : ""}
                  {candidate.price !== null && candidate.price !== undefined ? ` · ${money(candidate.price, lang)}` : ""}
                </span>
              </Button>
            ))}
          </div>
        </fieldset>
      ))}
    </div>
  );
}

export default function CopilotMessage({ message, plan, t, lang, canWrite, busy, isLatestClarify, onChoose, planActions }) {
  const mine = message.role === "user";
  return (
    <li className={`copilot-msg ${mine ? "is-user" : "is-assistant"} kind-${message.kind}`}>
      {message.text && (
        <p className="copilot-bubble" dir="auto">
          {message.kind === "error" && <AlertTriangle size={14} aria-hidden="true" />}
          {message.kind === "result" && <CheckCircle size={14} aria-hidden="true" />} {message.text}
        </p>
      )}
      {message.kind === "query" && <QueryResult data={message.data} t={t} lang={lang} />}
      {message.kind === "clarify" && isLatestClarify && message.data?.slots?.length > 0 && <Clarification data={message.data} t={t} lang={lang} disabled={busy} onChoose={onChoose} />}
      {message.kind === "plan" && plan && <CopilotPlanCard plan={plan} t={t} lang={lang} canWrite={canWrite} busy={busy} {...planActions(plan)} />}
    </li>
  );
}
